<div class="tabMobSidePadding">
    <volvo-contact-skeleton *ngIf="isLoading"></volvo-contact-skeleton>

    <button (click)="navigateToCentres()" class="backButton">
        <img src="/assets/pages/truckModel/ArrowLeft.webp" />
        Back
    </button>

    <section class="truckCentre">
        <div class="truckCentre tabMobHeroMargin">
            <img [hidden]="isLoading" (load)="onImageLoad()" (error)="onError()"
                [ngClass]="region===regionEnum.TX?'tx':''" [src]="getImageSrc()" class="truckCentre-centreImg" alt="">
        </div>
    </section>
    <div [hidden]="isLoading">
        <section class="banburryCentre" id="tradeexport">
            <div class="banburryCentre-title">
                <h1>
                    {{region===regionEnum.UK?("uk/pages/contact/banburyTruckCentre" | lowercase | translate) :
                    ("uk/pages/tradeexport/title1/text2" | lowercase | translate) }}
                </h1>
            </div>
            <div class="banburryCentre-text"
                [innerHTML]="region===regionEnum.UK?('uk/pages/contact/banburyText' | lowercase | translate):('pages/contact/tradeandexportText'| lowercase | translate)">
            </div>
            <div *ngIf="region===regionEnum.TX" class="social-media-section">
                <div class="social-media-header">{{ "pages/contactus/socialmediaheader" | lowercase | translate }}:
                </div>
                <div class="social-media-links">
                    <a href="https://www.facebook.com/TradeExportTrucks" class="social-media-link" target="_blank">
                        <img src="/assets/icons/facebook.svg" class="social-media-icon" alt="Facebook icon">
                        <span class="social-media-text">{{ "components/footer/facebook" | lowercase | translate
                            }}</span>
                    </a>
                    <a href="https://www.linkedin.com/company/trade-and-export-trucks" class="social-media-link"
                        target="_blank">
                        <img src="/assets/icons/linkedIn.svg" class="social-media-icon" alt="LinkedIn icon">
                        <span class="social-media-text">{{ "uk/components/footer/linkedIn" | lowercase | translate
                            }}</span>
                    </a>
                </div>
            </div>
        </section>
        <section class="banburryCentre">
            <div class="banburryCentre-flex">
                <div *ngIf="region===regionEnum.TX">
                    <div class="banburryCentre-salesTeam">
                        <div class="banburryCentre-text txteam">{{"pages/contact/tradeandexportteam2"| lowercase |
                            translate}}</div>
                        <volvo-sales-person [salesTeamData]="salesTeamMangementDetails"></volvo-sales-person>
                    </div>
                    <div class="banburryCentre-salesTeam">
                        <div class="banburryCentre-text txteam">{{"pages/contact/tradeandexportteam"| lowercase |
                            translate}}</div>
                        <volvo-sales-person [salesTeamData]="salesTeamMangementDetailsTX"
                            class="marginTop"></volvo-sales-person>
                    </div>
                </div>
                <div *ngIf="region!==regionEnum.TX">
                    <div class="banburryCentre-salesTeam">
                        <volvo-sales-person [salesTeamData]="salesTeamMangementDetails"></volvo-sales-person>
                    </div>
                </div>
                <div class="banburryCentre-map">
                    <volvo-map-centre [centre]="mapCentre"></volvo-map-centre>
                </div>
            </div>
        </section>
    </div>
</div>